export default class DepartmentModel {
  id!: number;

  nomeDepartamento!: string;
}
